import { useEffect, useState } from "react"
import { WfmAbsence } from "../../../../services/actionsService"

const useAbsenceComments = (wfmAbsence?: WfmAbsence) => {
  const [comments, setComments] = useState<string>('')
  const [contactComments, setContactComments] = useState<string>('')
  const [wfmComments, setWfmComments] = useState<string>()

  useEffect(() => {
    if (!wfmAbsence) {
      return
    }

    setWfmComments(wfmAbsence.notes)
  }, [wfmAbsence])

  return {
    comments,
    setComments,
    contactComments,
    setContactComments,
    wfmComments,
  }
}

export default useAbsenceComments